<template>
  <div class="flex-col gap-y-sm">

    <div class="flex-col gap-y-sm" v-for="(cards, step) in overview">
      <template v-for="(fields, key) in cards">
        <dd-header-card
            :key="key"
            :collapsible="true"
            :collapsed="false"
            :header="key"
        >
          <template #action>
            <dd-button @click="$emit('go-to-step', step)" type="primary" icon="mdi mdi-pencil" class="square-button">
            </dd-button>
          </template>
          <dd-card-list :list="fields">

          </dd-card-list>
        </dd-header-card>
      </template>

    </div>
  </div>
</template>

<script>
import RenderableComponentToComponentEnum from '../../../../new_design_components/enums/RenderableComponentToComponentEnum.js'
import { mapState, mapMutations, mapGetters } from 'vuex';
export default {
  name: "Overview",
  emits: ['go-to-step'],
  computed: {
    ...mapState(`$_generic_insurance`, {
      'form': 'form',
    }),
    ...mapGetters(`$_generic_insurance`, {
      fieldsGroupedByView: 'fieldsGroupedByView',
    }),
    ...mapState(`$_policy_edit`, {
      overview: (state) => state.overview,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
